  <div [config]="{ show: true, backdrop: 'static' }" bsModal #autoShownModal="bs-modal" class="modal fade" tabindex="-1"
    role="dialog" aria-hidden="true">
    <div class="custom-theme-modal modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header py-3 d-flex border-color">
          <div class="text-left">
            <span ngbDropdown class="d-inline-block mr-3 ngb-dropdown-list px-2">
              <span>
              <span id="dropdownBasic1" ngbDropdownToggle class="cursor-pointer secondary-paragraph-bold">
                Change Size
              </span>
              </span>
              <img src="assets/themes/icons/down-arrow.svg" width="16" alt="down arrow">
              <!-- ngbDropdownItem -->
              <div ngbDropdownMenu class="secondary-paragraph p-2" aria-labelledby="dropdownBasic1">
                <div>
                  <a (click)="setPencilSize(3)" ngbDropdownItem class="cursor-pointer d-block p-0 mt-1 mb-1">
                    <span class="d-block size-3"></span>
                  </a>
                  <a (click)="setPencilSize(5)" ngbDropdownItem class="cursor-pointer d-block p-0 mt-1 mb-1"><span
                      class="d-block size-5"></span></a>

                  <a (click)="setPencilSize(8)" ngbDropdownItem class="cursor-pointer d-block p-0 mt-1 mb-1"><span
                      class="d-block size-8"></span></a>
                </div>
              </div>
            </span>
            <div class="float-right">
              <p class="secondary-paragraph">Color:</p>
              <div class="clearfix">
                <span (click)="selectColor('black')"
                  class="box-size-20 rounded-circle float-left mr-2 bg-black cursor-poiner"></span>
                <span (click)="selectColor('blue')"
                  class="box-size-20 rounded-circle float-left mr-2 bg-info-blue cursor-poiner"></span>
                <span (click)="selectColor('yellow')"
                  class="box-size-20 rounded-circle float-left mr-2 bg-warning cursor-poiner"></span>
                <span (click)="selectColor('red')"
                  class="box-size-20 rounded-circle float-left mr-2 bg-error cursor-poiner"></span>
                <span (click)="selectColor('green')"
                  class="box-size-20 rounded-circle float-left mr-2 bg-success cursor-poiner"></span>
              </div>
            </div>
          </div>
          <div class="text-right">
          <span (click)="resetModal()">
            <img class="meta-icon cursor-pointer" src="assets/themes/icons/cancel.svg" alt="cross">
          </span>
          </div>
        </div>
        <div class="modal-body">
          <canvas #canvas_edit_image id="canvas_edit_image"></canvas>
        </div>
        <div class="modal-footer d-block">
          <div>
            
            <div class="text-center">
              <button type="button" (click)="saveImage()" class="btn-design filled medium">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>